<script>
    import HeaderLogo from './intakeForm/HeaderLogo.vue'
    import HeaderInfo from './intakeForm/HeaderInfo.vue'
    import UploadDocuments from './intakeForm/UploadDocuments.vue'
    import MaritalStatus from './intakeForm/MaritalStatus.vue'
    import PersonalInformation from './intakeForm/PersonalInformation.vue'
    import FormFileMultipleInput from '../../components/forms/FormFileMultipleInput.vue'
    import axios from 'axios'

    export default {
        components: {
            HeaderLogo,
            HeaderInfo,
            PersonalInformation,
            MaritalStatus,
            UploadDocuments,
            FormFileMultipleInput
        },
        props: {
            parentCompanyLogo: String,
            parentDetails: Object,
            relationshipsData: Array,
            suffixesData: Array,
            statesData: Array
        },
        data() {
            return {
                accordianData: [
                    {
                        id: 1,
                        buttonText: 'Part I - Your Personal Information'
                    },
                    {
                        id: 2,
                        buttonText: 'Part II - Marital Status, Household and Dependent Information'
                    }
                ],
                allIntakeData: {
                    personalInformation: {
                        name: '',
                        middle_initials: '',
                        primary_suffix: '',
                        your_security_number: '',
                        home_address: '',
                        apt_no: '',
                        state: '',
                        city: '',
                        zipcode: '',
                        primary_dob: '',
                        email: '',
                        phone: '',
                        password: '',
                        password_confirmation: '',
                        intake_id: window.location.pathname.split("/")[2],
                        deviceToken: localStorage.getItem('deviceToken'),
                        expirationDate: localStorage.getItem('expirationDate'),
                        errors: {
                            name: null,
                            middle_initials: null,
                            primary_suffix: null,
                            your_security_number: null,
                            home_address: null,
                            apt_no: null,
                            state: null,
                            city: null,
                            zipcode: null,
                            primary_dob: null,
                            email: null,
                            phone: null,
                            password: null,
                            password_confirmation: null
                        }
                    },
                    maritalStatus: {
                        status: '',
                        error: null
                    },
                    spouseInfo: {
                        name: '',
                        middleInitial: '',
                        suffix: '',
                        dob: '',
                        ssn: '',
                        errors: {
                            spouse_name: null,
                            spouse_middle_initials: null,
                            spouse_suffix: null,
                            spouse_dob: null,
                            spouse_security_number: null
                        }
                    },
                    dependentDetails: {
                        status: '',
                        dependents: [{
                            name: '',
                            middleInitial: '',
                            suffix: '',
                            ssn: '',
                            dob: '',
                            relationship: '',
                            nameError: null,
                            ssnError: null,
                            dobError: null,
                            relationshipError: null,
                        }]
                    },
                    agreementStatus: false,
                    agreementStatusError: null,
                    filesDetails: {
                        all_files: null,
                        errors: null,
                        otherError: null
                    }
                },
                submitButtonText: 'Submit',
            }
        },
        methods: {
            handleIntakeFormSubmit() {
                this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>Loading`;
                this.$refs.topProgress.start()
                let dependentsErrFlag = false
                let openAccordianId = 0
                this.allIntakeData.personalInformation.errors = {
                    name: null,
                    middle_initials: null,
                    primary_suffix: null,
                    your_security_number: null,
                    home_address: null,
                    apt_no: null,
                    state: null,
                    city: null,
                    zipcode: null,
                    primary_dob: null,
                    email: null,
                    phone: null,
                    password: null,
                    password_confirmation: null
                }

                this.allIntakeData.maritalStatus.error = null

                this.allIntakeData.spouseInfo.errors = {
                    spouse_name: null,
                    spouse_middle_initials: null,
                    spouse_suffix: null,
                    spouse_dob: null,
                    spouse_security_number: null
                }

                this.allIntakeData.agreementStatusError = null
                let nameRegex = /^[a-zA-Z]+[a-zA-Z\s]*$/;
                let multiFiles = this.$refs.fileupload.fileUpload();
                let formData = new FormData()
                /*
                    Add the form data we need to submit
                */
                for (const key in this.allIntakeData.personalInformation) {
                    if(key != 'errors') {
                        if(key == 'state') {
                            formData.append(key, this.allIntakeData.personalInformation[key].state_code ? this.allIntakeData.personalInformation[key].state_code + ':' + this.allIntakeData.personalInformation[key].name : '')
                        } else if(key == 'primary_suffix'){
                          formData.append(key, this.allIntakeData.personalInformation[key].suffix ? this.allIntakeData.personalInformation[key].suffix : '')
                        } else {
                            formData.append(key, this.allIntakeData.personalInformation[key])
                        }
                    }
                }
                if(this.allIntakeData.dependentDetails.status == 'yes') {
                    this.allIntakeData.dependentDetails.dependents.forEach((element, index, array) => {
                        if(!this.allIntakeData.dependentDetails.dependents[index]['name'].length) {
                            this.allIntakeData.dependentDetails.dependents[index]['nameError'] = 'Please enter full name.'
                            dependentsErrFlag = true
                        } else if(this.allIntakeData.dependentDetails.dependents[index]['name'].length < 2) {
                            this.allIntakeData.dependentDetails.dependents[index]['nameError'] = 'Full Name is too small.'
                            dependentsErrFlag = true
                        } else if(this.allIntakeData.dependentDetails.dependents[index]['name'].length > 255) {
                            this.allIntakeData.dependentDetails.dependents[index]['nameError'] = 'Full Name is too large.'
                            dependentsErrFlag = true
                        }  else if(!nameRegex.test(this.allIntakeData.dependentDetails.dependents[index]['name'])) {
                            this.allIntakeData.dependentDetails.dependents[index]['nameError'] = 'Full Name must contain with letters and space.'
                            dependentsErrFlag = true
                        } else {
                            this.allIntakeData.dependentDetails.dependents[index]['nameError'] = null
                            dependentsErrFlag = false
                        }

                        if(this.allIntakeData.dependentDetails.dependents[index]['ssn'].length && this.allIntakeData.dependentDetails.dependents[index]['ssn'].length != 9) {
                            this.allIntakeData.dependentDetails.dependents[index]['ssnError'] = 'SSN/ITIN must be 9 digits.'
                            dependentsErrFlag = true
                        } else {
                            this.allIntakeData.dependentDetails.dependents[index]['ssnError'] = null
                            dependentsErrFlag = false
                        }
                        
                        if(!this.allIntakeData.dependentDetails.dependents[index]['relationship']) {
                            this.allIntakeData.dependentDetails.dependents[index]['relationshipError'] = 'Relationship is required.'
                            dependentsErrFlag = true
                        } else {
                            this.allIntakeData.dependentDetails.dependents[index]['relationshipError'] = null
                            dependentsErrFlag = false
                        }

                        if(!this.allIntakeData.dependentDetails.dependents[index]['dob'].length) {
                            this.allIntakeData.dependentDetails.dependents[index]['dobError'] = 'DOB is required.'
                            dependentsErrFlag = true
                        } else {
                            this.allIntakeData.dependentDetails.dependents[index]['dobError'] = null
                            dependentsErrFlag = false
                        }
                    })

                    if(dependentsErrFlag) {
                        this.$refs.topProgress.done()
                    }
                }
                if(!dependentsErrFlag) {
                    formData.append('filing_status', this.allIntakeData.maritalStatus.status)
                    formData.append('spouse_name', this.allIntakeData.spouseInfo.name)
                    formData.append('spouse_middle_initials', this.allIntakeData.spouseInfo.middleInitial)
                    formData.append('spouse_suffix', this.allIntakeData.spouseInfo.suffix.suffix ? this.allIntakeData.spouseInfo.suffix.suffix : '')
                    formData.append('spouse_dob', this.allIntakeData.spouseInfo.dob)
                    formData.append('spouse_security_number', this.allIntakeData.spouseInfo.ssn)
                    formData.append('dependentStatus', this.allIntakeData.dependentDetails.status)
                    formData.append('allDependents', JSON.stringify(this.allIntakeData.dependentDetails.dependents))
                    if(this.allIntakeData.agreementStatus) {
                        formData.append('agreementStatus', this.allIntakeData.agreementStatus)
                    }

                    for(let i = 0; i < multiFiles.length; i++) {
                        formData.append('attachment[]', multiFiles[i])
                    }
                    axios.post(
                    route('intake-form-registration-save'),
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        this.$toastr.s(response.data.message)
                        window.location.href = route('tp-dashboard')
                        this.$refs.topProgress.done()
                    })
                    .catch(err => {
                        if(err.response.status == 422) {
                            this.$refs.fileupload.$refs.showfilesname.innerHTML = ''
                            this.allIntakeData.filesDetails.errors = ''
                            for(let k = 0; k < multiFiles.length; k++) {
                                if(err.response.data.errors['attachment.' + k] != undefined) {
                                    this.allIntakeData.filesDetails.errors += '<i class="mdi mdi-circle-medium"></i> ' + multiFiles[k]['name'] + ' <span class="text-danger">' + err.response.data.errors['attachment.' + k][0] +'</span><br>'
                                } else {
                                    this.allIntakeData.filesDetails.errors += '<i class="mdi mdi-circle-medium"></i> ' + multiFiles[k]['name'] + '<br>'
                                }
                            }
                            this.$refs.fileupload.showError(this.allIntakeData.filesDetails.errors)
                            for(const key in err.response.data.errors) {
                                if(key == 'filing_status') {
                                    this.allIntakeData.maritalStatus.error = err.response.data.errors[key] ? err.response.data.errors[key][0] : null
                                    openAccordianId = 2
                                } else if(key == 'agreementStatus') {
                                    this.allIntakeData.agreementStatusError = err.response.data.errors[key] ? err.response.data.errors[key][0] : null
                                } else if(key == 'spouse_name' || key == 'spouse_dob' || key == 'spouse_security_number') {
                                    this.allIntakeData.spouseInfo.errors[key] = err.response.data.errors[key] ? err.response.data.errors[key][0] : null
                                    openAccordianId = 2
                                } else {
                                    this.allIntakeData.personalInformation.errors[key] = err.response.data.errors[key] ? err.response.data.errors[key][0] : null
                                    openAccordianId = 1
                                }
                            }
                            this.showAccordianBody(openAccordianId, 'formValidation')
                        }
                        if(err.response.status == 400) {
                            this.$toastr.e(err.response.data.message)
                        }
                        this.$refs.topProgress.done()
                        this.submitButtonText = `Submit`;
                    })
                } else {
                    this.$refs.topProgress.done()
                    this.showAccordianBody(2, 'formValidation')
                    this.submitButtonText = `Submit`;
                }
            },
            showAccordianBody(id, location) {
                if(id > 0) {
                    if (this.$refs["details_" + id][0].classList.contains("show") && location == 'accordian') {
                        this.$refs["details_" + id][0].classList.remove("show")
                        this.$refs["button_" + id][0].classList.add("collapsed")
                    } else {
                        var elements =
                            document.getElementsByClassName("accordion-collapse")
                        var buttonElements =
                            document.getElementsByClassName("accordion-button")
                        for (var i = 0; i < elements.length; i++) {
                            elements[i].classList.remove("show")
                        }
                        for (var j = 0; j < buttonElements.length; j++) {
                            buttonElements[j].classList.add("collapsed")
                        }
                        this.$refs["details_" + id][0].classList.add("show")
                        this.$refs["button_" + id][0].classList.remove("collapsed")
                    }
                }
            },
            addDependent() {
                this.allIntakeData.dependentDetails.dependents.push({
                    name: '',
                    middleInitial: '',
                    suffix: '',
                    ssn: '',
                    dob: '',
                    relationship: '',
                    nameError: null,
                    ssnError: null,
                    dobError: null,
                    relationshipError: null
                })
            },
            deleteDependent(index) {
                this.allIntakeData.dependentDetails.dependents.splice(index, 1)
            }
        },

        computed: {
            headerLogo() {
                if (this.parentCompanyLogo.length) {
                    return this.parentCompanyLogo
                } else {
                    return "/public/new_design/before_login/images/seqwens-logo3.png"
                }
            },
            headerRightSideDetails() {
                let details = ""
                if (
                    this.parentDetails["company_name"] &&
                    this.parentDetails["company_name"].length
                ) {
                    details += this.parentDetails["company_name"] + ", "
                }

                details +=
                    this.parentDetails["email"] +
                    ", " +
                    this.parentDetails["phone_country_code"] +
                    " " +
                    this.parentDetails["phone"]

                return details
            },
        },
    }
</script>

<template>
    <div class="account-pages pt-sm-5">
        <Head title="Intake Form" />
        <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
        <div class="container">
            <div class="justify-content-center">
                <div class="col-lg-12">
                    <HeaderLogo :headerLogo="headerLogo"/>
                    <div class="card">
                        <HeaderInfo :details="headerRightSideDetails"/>
                        <div class="card-body">
                            <div class="accordion">
                                <div v-for="(item, index) in accordianData" class="accordion-item" :key="index">
                                    <h2
                                        class="accordion-header"
                                        :id="`heading${item.id}`"
                                    >
                                        <button
                                            class="accordion-button fw-medium"
                                            :class="index > 0 ? 'collapsed' : ''"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            :data-bs-target="`#collapse${item.id}`"
                                            :aria-expanded="!index ? true : false"
                                            :aria-controls="`collapse${item.id}`"
                                            :ref="`button_${item.id}`"
                                            @click="showAccordianBody(item.id, 'accordian')"
                                        >
                                            {{ item.buttonText }}
                                        </button>
                                    </h2>
                                    <div
                                        :ref="'details_' + item.id"
                                        :id="`collapse${item.id}`"
                                        class="accordion-collapse collapse"
                                        :class="{'show': !index}"
                                        :aria-labelledby="`heading${item.id}`"
                                    >
                                        <div v-if="item.id == 1" class="accordion-body">
                                            <PersonalInformation 
                                                :suffixesData="suffixesData"
                                                :statesData="statesData"
                                                :personalInformation="allIntakeData.personalInformation"
                                            />
                                        </div>
                                        <div v-else class="accordion-body">
                                            <MaritalStatus 
                                                :suffixesData="suffixesData"
                                                :relationshipsData="relationshipsData"
                                                :maritalStatus="allIntakeData.maritalStatus"
                                                :spouseInfo="allIntakeData.spouseInfo"
                                                :dependentDetails="allIntakeData.dependentDetails"
                                                @addDependent="addDependent"
                                                @deleteDependent="deleteDependent"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <UploadDocuments> 
                                <form ref="uploadFileForm" enctype="multipart/form-data">
                                    <FormFileMultipleInput ref="fileupload"
                                        :isShowLabel="false" 
                                        v-model='allIntakeData.filesDetails.all_files'
                                        :required="false"
                                        :error="allIntakeData.filesDetails.otherError"
                                        name="attachment"
                                    />
                                    <div
                                        v-if="allIntakeData.filesDetails.otherError"
                                        class="invalid-feedback"
                                    >
                                        {{ allIntakeData.filesDetails.otherError }}
                                    </div>
                                </form>
                            </UploadDocuments>                            
                            <div
                                class="form-group mb-2"
                            >
                                <input
                                    type="checkbox"
                                    tabindex="3"
                                    v-model="allIntakeData.agreementStatus"
                                    class="check_field"
                                    id="terms-conditions"
                                    :class="{'is-invalid': allIntakeData.agreementStatusError}"
                                />
                                <label
                                    for="terms-conditions"
                                >
                                    <p
                                        class="agree_register_form"
                                        style="
                                            padding: 0px;
                                            display: inline-block;
                                            line-height: normal;
                                            margin: 0px;
                                            margin-left: 7px;
                                        "
                                    >
                                        I agree to the
                                        <a
                                            href="https://seqwens.com/software-service-agreement"
                                            target="_blank"
                                            >software
                                            agreement</a
                                        >
                                        of SeQwens
                                    </p>
                                </label>
                                <div
                                    v-if="allIntakeData.agreementStatusError"
                                    class="invalid-feedback"
                                >
                                    {{ allIntakeData.agreementStatusError }}
                                </div>
                            </div>
                            <div
                                class="d-flex align-items-center mt-4 mb-4 gap-2"
                            >
                                <p>
                                    If you believe your tax return information has been disclosed or used improperly in a manner unauthorized by law or without your permission, visit the following website for more assistance.
                                    <a
                                        href="https://www.irs.gov/newsroom/taxpayer-guide-to-identity-theft"
                                        target="_blank"
                                    >
                                        https://www.irs.gov/newsroom/taxpayer-guide-to-identity-theft
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <button type="button" class="btn btn-success waves-effect waves-light" @click="handleIntakeFormSubmit" v-html="submitButtonText" :disabled="submitButtonText != 'Submit'">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.accordion-button.collapsed {
    background: #babdc8;
}
.accordion-button:not(.collapsed) {
    color: #4d63cf;
    background-color: #9699a6;
}
</style>
